import { c as _c } from "react/compiler-runtime";
import { Avatar, Box, Card, Flex, Heading, HStack, Icon, Separator, SimpleGrid, Stack, Text, VStack } from '@chakra-ui/react';
import { MarkdownRenderer } from '@src/components/sco/MarkdownRenderer';
import { CoherencePanel } from '@src/components/sco/PitchDeckAuditor/main/CoherencePanel';
import { CriticalIssuesList } from '@src/components/sco/PitchDeckAuditor/main/CriticalIssuesList';
import { FrameworkScorecard } from '@src/components/sco/PitchDeckAuditor/main/FrameworkScorecard';
import { PitchDeckView } from '@src/components/sco/PitchDeckAuditor/model/types';
import { RatingBadge } from '@src/components/sco/PitchDeckAuditor/nav/RatingBadge';
import { ScoreRing } from '@src/components/sco/PitchDeckAuditor/shared/ScoreRing';
import { SectionHeading } from '@src/components/sco/PitchDeckAuditor/shared/SectionHeading';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { LuListChecks, LuMessageSquareQuote, LuRadar, LuTriangleAlert } from 'react-icons/lu';
export function DeckOverview(t0) {
  const $ = _c(77);
  const {
    deck,
    onSelectSlide
  } = t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([true, true, false, false, false]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isMobile = t1;
  let t2;
  if ($[2] !== deck.stats.problems) {
    t2 = {
      value: deck.stats.problems,
      label: "Problems",
      color: "fg"
    };
    $[2] = deck.stats.problems;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== deck.stats.critical) {
    t3 = {
      value: deck.stats.critical,
      label: "Critical",
      color: "red.fg"
    };
    $[4] = deck.stats.critical;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== deck.stats.quickWins) {
    t4 = {
      value: deck.stats.quickWins,
      label: "Quick wins",
      color: "teal.fg"
    };
    $[6] = deck.stats.quickWins;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = [t2, t3, t4];
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const stats = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <HStack color="fg.subtle" gap={3} marginY={2}><Text color="colorPalette.fg" textStyle="labelXs">Startups.com Pitch Deck Audit</Text><Separator flex={1} /></HStack>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = isMobile ? "2xl" : "4xl";
  let t8;
  if ($[13] !== deck.companyName || $[14] !== t7) {
    t8 = <Heading lineHeight="shorter" size={t7}>{deck.companyName}</Heading>;
    $[13] = deck.companyName;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = isMobile ? "xs" : "sm";
  const t10 = deck.fileName ? ` · ${deck.fileName}` : "";
  let t11;
  if ($[16] !== deck.slideCount || $[17] !== t10 || $[18] !== t9) {
    t11 = <Text color="colorPalette.fg/50" fontSize={t9} fontWeight="semibold">Full Deck Audit · {deck.slideCount} slides{t10}</Text>;
    $[16] = deck.slideCount;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t8) {
    t12 = <VStack align="stretch" gap={2}>{t6}<HStack align="center" gap={2} justify="space-between" wrap="wrap">{t8}{t11}</HStack></VStack>;
    $[20] = t11;
    $[21] = t8;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = isMobile ? "column" : "row";
  const t14 = isMobile ? 4 : 10;
  const t15 = isMobile ? "4xl" : "lg";
  const t16 = isMobile ? "5xl" : "xl";
  const t17 = isMobile ? "12px" : "7px";
  let t18;
  if ($[23] !== deck.overallScore || $[24] !== t15 || $[25] !== t16 || $[26] !== t17) {
    t18 = <ScoreRing headingSize={t15} score={deck.overallScore} size={t16} thickness={t17} />;
    $[23] = deck.overallScore;
    $[24] = t15;
    $[25] = t16;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  const t19 = deck.overallRatingKey === "notAudited" ? "Audited" : deck.overallRatingKey === "needsWork" ? "Needs Work" : undefined;
  let t20;
  if ($[28] !== deck.overallRatingKey || $[29] !== t19) {
    t20 = <RatingBadge ratingKey={deck.overallRatingKey} size="sm" label={t19} />;
    $[28] = deck.overallRatingKey;
    $[29] = t19;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t18 || $[32] !== t20) {
    t21 = <VStack gap={2}>{t18}{t20}</VStack>;
    $[31] = t18;
    $[32] = t20;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== deck.verdict) {
    t22 = deck.verdict && <Text fontSize="md" fontWeight="medium">{deck.verdict}</Text>;
    $[34] = deck.verdict;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== t22) {
    t23 = <Box flex={1} minWidth="200px">{t22}</Box>;
    $[36] = t22;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t13 || $[39] !== t14 || $[40] !== t21 || $[41] !== t23) {
    t24 = <Flex align="center" direction={t13} gap={t14}>{t21}{t23}</Flex>;
    $[38] = t13;
    $[39] = t14;
    $[40] = t21;
    $[41] = t23;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== getBreakpointValue) {
    t25 = getBreakpointValue([1, 1, 3]);
    $[43] = getBreakpointValue;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== stats) {
    t26 = stats.map(_temp);
    $[45] = stats;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] !== t25 || $[48] !== t26) {
    t27 = <SimpleGrid columns={t25} gap={3}>{t26}</SimpleGrid>;
    $[47] = t25;
    $[48] = t26;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== t24 || $[51] !== t27) {
    t28 = <Card.Root bgColor="colorPalette.solid/40" borderColor="colorPalette.focusRing" borderWidth="1px" variant="elevated"><Card.Body gap={6}>{t24}{t27}</Card.Body></Card.Root>;
    $[50] = t24;
    $[51] = t27;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] !== deck.overview || $[54] !== isMobile) {
    t29 = deck.overview && <Card.Root bg="orange.subtle/50" borderColor="orange.muted" borderWidth="1px"><Card.Body><Stack align="flex-start" direction={isMobile ? "column" : "row"} gap={4}><Icon as={LuMessageSquareQuote} boxSize={6} color="orange.fg" mt={1} /><Box><Box fontFamily="longform" fontSize="md" fontStyle="italic"><MarkdownRenderer preset="chat-message">{deck.overview}</MarkdownRenderer></Box><HStack gap={2} mt={isMobile ? 6 : 4}><Avatar.Root colorPalette="orange" size="xs"><Avatar.Fallback name="Wil Schroter" /></Avatar.Root><Text color="fg.muted" letterSpacing="widest" textStyle="label2xs">Wil Schroter · Startups.com</Text></HStack></Box></Stack></Card.Body></Card.Root>;
    $[53] = deck.overview;
    $[54] = isMobile;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t12 || $[57] !== t28 || $[58] !== t29) {
    t30 = <VStack align="stretch" gap={4}>{t12}{t28}{t29}</VStack>;
    $[56] = t12;
    $[57] = t28;
    $[58] = t29;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <Separator />;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <SectionHeading icon={LuTriangleAlert} textStyle="lg">Top Critical Issues</SectionHeading>;
    $[61] = t32;
  } else {
    t32 = $[61];
  }
  let t33;
  if ($[62] !== deck.criticalIssues || $[63] !== onSelectSlide) {
    t33 = <VStack align="stretch" gap={4}>{t32}<CriticalIssuesList issues={deck.criticalIssues} onSelectSlide={onSelectSlide} /></VStack>;
    $[62] = deck.criticalIssues;
    $[63] = onSelectSlide;
    $[64] = t33;
  } else {
    t33 = $[64];
  }
  let t34;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <SectionHeading icon={LuListChecks} textStyle="lg">Framework Scorecard</SectionHeading>;
    $[65] = t34;
  } else {
    t34 = $[65];
  }
  let t35;
  if ($[66] !== deck || $[67] !== onSelectSlide) {
    t35 = <VStack align="stretch" gap={4}>{t34}<FrameworkScorecard deck={deck} onSelectSlide={onSelectSlide} /></VStack>;
    $[66] = deck;
    $[67] = onSelectSlide;
    $[68] = t35;
  } else {
    t35 = $[68];
  }
  let t36;
  if ($[69] !== deck.coherence) {
    t36 = deck.coherence.length > 0 && <VStack align="stretch" gap={4}><SectionHeading icon={LuRadar} textStyle="lg">Cross-Slide Coherence</SectionHeading><CoherencePanel coherence={deck.coherence} /></VStack>;
    $[69] = deck.coherence;
    $[70] = t36;
  } else {
    t36 = $[70];
  }
  let t37;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <Box pb={4} />;
    $[71] = t37;
  } else {
    t37 = $[71];
  }
  let t38;
  if ($[72] !== t30 || $[73] !== t33 || $[74] !== t35 || $[75] !== t36) {
    t38 = <VStack align="stretch" gap={8}>{t30}{t31}{t33}{t35}{t36}{t37}</VStack>;
    $[72] = t30;
    $[73] = t33;
    $[74] = t35;
    $[75] = t36;
    $[76] = t38;
  } else {
    t38 = $[76];
  }
  return t38;
}
function _temp(stat) {
  return <Card.Root key={stat.label} bgColor="colorPalette.card" borderRadius="md" boxShadow="sm" size="sm" variant="subtle"><Card.Body py={3} textAlign="center"><Heading color={stat.color} size="lg">{stat.value}</Heading><Text color="colorPalette.fg/50" textStyle="label2xs">{stat.label}</Text></Card.Body></Card.Root>;
}